export const SkeletonRows = ({ columns }) => (
    <tbody>
      {[...Array(6)].map((_, rowIndex) => (
        <tr key={rowIndex} className="animate-pulse border-b border-white/10">
          {columns.map((_, colIndex) => (
            <td key={colIndex} className="px-4 py-3">
              <div className="h-3 w-5/6 bg-white/20 rounded" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
  